import { Stack, Tabs } from '@mantine/core';
import { PlanType } from 'api/models';
import { PageTitle } from 'components/PageTitle';
import { i18nKeys, type TranslateFunction, useTranslation } from 'locales';
import { useState } from 'react';
import { type RouteComponentProps, useHistory } from 'react-router';
import { RecoverySettingsCard } from './RecoverySettings';
import { ReminderThresholdsCard } from './ReminderThresholds';
import { NewPaymentWorkflowButton, NewRecoveryPlanButton } from './WorkflowsTable/NewPlanButtons';
import { PaymentWorkflowsTable } from './WorkflowsTable/PaymentWorkflowsTable';
import { RecoveryPlansTable } from './WorkflowsTable/RecoveryPlansTable';

export const WorkflowsSettings = ({ location }: RouteComponentProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const tabItems = getTabItems(t);

  const [activePath, setActivePath] = useState(
    tabItems.find(item => item.path === location.pathname)?.path ?? tabItems[0].path,
  );
  const activeTab = tabItems.find(item => item.path === activePath) ?? tabItems[0];

  return (
    <>
      <PageTitle>
        {t(i18nKeys.AUTOMATED_PLANS)}
        <PageTitle.Actions>{activeTab.action}</PageTitle.Actions>
      </PageTitle>
      <Tabs
        value={activePath}
        onChange={value => {
          if (!value) return;
          setActivePath(value);
          history.push(value);
        }}
      >
        <Tabs.List w="100%">
          {tabItems.map(({ path, title }) => (
            <Tabs.Tab key={path} value={path}>
              {title}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {tabItems.map(({ path, children }) => (
          <Tabs.Panel key={path} value={path} mt="xl">
            {children}
          </Tabs.Panel>
        ))}
      </Tabs>
    </>
  );
};

function getTabItems(t: TranslateFunction) {
  return [
    {
      title: t(i18nKeys.BATCH.CATEGORIES.RECOVERY),
      path: '/settings/workflows/recovery-plans',
      action: <NewRecoveryPlanButton />,
      children: (
        <Stack gap="xl">
          <RecoveryPlansTable />
          <RecoverySettingsCard />
          <ReminderThresholdsCard />
        </Stack>
      ),
    },
    {
      title: t(i18nKeys.PAYMENT_PLAN.TITLE.ONE),
      path: `/settings/workflows/${PlanType.payment}`,
      action: <NewPaymentWorkflowButton />,
      children: <PaymentWorkflowsTable />,
    },
  ];
}
